import React, { createContext, useContext, useEffect, useState, useCallback } from 'react'
import Session from 'react-session-api'

// Holds the cart badge count so adding a registration updates the navbar without a page reload.
// The cart's contents and prices are not cached here — those come from /cart/quote on the cart page
// itself, because every figure has to be a live server calculation.

const CartContext = createContext({ count: 0, refreshCount: () => {} })

export function CartProvider({ children }) {
   const [count, setCount] = useState(0)

   const refreshCount = useCallback(async () => {
      // The cart is individual-account only, so there is nothing to fetch for anyone else.
      if (Session.get('isAuth') !== 'true' || Session.get('accountType') !== 'individual') {
         setCount(0)
         return
      }
      try {
         const response = await fetch('/cart/count', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
         })
         if (!response.ok) {
            setCount(0)
            return
         }
         const data = await response.json()
         setCount(data.count ?? 0)
      } catch {
         setCount(0)
      }
   }, [])

   useEffect(() => {
      refreshCount()
   }, [refreshCount])

   return (
      <CartContext.Provider value={{ count, refreshCount }}>
         {children}
      </CartContext.Provider>
   )
}

export function useCart() {
   return useContext(CartContext)
}

export default CartContext
